import { useFeatureEnabled } from './useFeatureEnabled';

function useFeatureEditReservationMemberPortal(): boolean {
  return useFeatureEnabled('EDIT_ADD_TRIP_LEG_V2_MP');
}

function useFeatureEditReservationClientPortal(): boolean {
  return useFeatureEnabled('EDIT_ADD_TRIP_LEG_V2_CP');
}

function useFeatureEditReservationF1(): boolean {
  return useFeatureEnabled('EDIT_ADD_TRIP_LEG_V2_F1');
}

export {
  useFeatureEditReservationMemberPortal,
  useFeatureEditReservationClientPortal,
  useFeatureEditReservationF1,
};
